<template>
  <img
    :src="source"
    :alt="alt"
    :title="title" />
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Imager',
  data () {
    return {
    }
  },
  props: {
    src: {
      type: String,
      required: true
    },
    alt: String,
    title: String
  },
  mounted () {
  },
  computed: {
    ...mapGetters(['isWebP']),
    source () {
      // require特性 必须用模板字符串在变量前用字符串包裹才不会报错
      // eslint-disable-next-line
      // const str = require(`@/${this.src}.${this.isWebP ? 'webp' : 'png'}`)
      return ''
    }
  }

}
</script>

<style>

</style>
